import { render, staticRenderFns } from "./CreateFixedCost.vue?vue&type=template&id=46d850ef&"
import script from "./CreateFixedCost.vue?vue&type=script&lang=js&"
export * from "./CreateFixedCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports